import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Mail, MapPin, Phone } from "lucide-react";
import { PHONE_HREF, PHONE_DISPLAY, EMAIL_HREF, EMAIL_DISPLAY, trackPhoneCall } from "@/lib/contact";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 border-t border-white/10 bg-[#0A0A0A]"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Logo size="lg" />
          <p className="mt-5 text-sm text-zinc-400 leading-relaxed max-w-xs">
            Modern, professional vending machines — installed, stocked & serviced
            at qualifying workplaces for $0 upfront.
          </p>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FE7200]">
            Site
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            {[
              ["Home", "/"],
              ["Services", "/services"],
              ["Free Vending Machines", "/free-vending-machines-for-businesses"],
              ["Buy a Machine", "/buy-a-vending-machine"],
              ["Blog", "/blog"],
              ["Contact Us", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}-link`}
                  className="text-zinc-300 hover:text-[#FE7200] transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FE7200]">
            Legal
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            {[
              ["About Us", "/about"],
              ["Privacy Policy", "/privacy"],
              ["Terms And Conditions", "/terms"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}-link`}
                  className="text-zinc-300 hover:text-[#FE7200] transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FE7200]">
            Contact
          </div>
          <ul className="mt-4 space-y-3 text-sm text-zinc-300">
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 text-[#FE7200] mt-0.5" />
              <a
                data-testid="footer-phone-link"
                href={PHONE_HREF}
                onClick={trackPhoneCall}
                className="text-white font-semibold hover:text-[#FE7200] transition-colors"
              >
                {PHONE_DISPLAY}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 text-[#FE7200] mt-0.5" />
              <a
                data-testid="footer-email-link"
                href={EMAIL_HREF}
                className="hover:text-white"
              >
                {EMAIL_DISPLAY}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 text-[#FE7200] mt-0.5" />
              <span>Country-wide service</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 md:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
          <div>© 2026 Anytime Vending Machines. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-bottom-privacy">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-bottom-terms">
              Terms
            </Link>
            <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
